/* Anemoia — sold pieces.

   Every piece is one of one, so selling is the normal end of a piece's life here, not an error.
   Shopify's default "Sold out" implies a restock we can never do; the label is "Sold" — the
   auction-house register, and the fastest thing to read on a small grid badge.

   The label itself now comes from the locale string products.product.sold_out, so it is rendered
   by the server on the grid, in search, on the product badge and on the buy button, with no flash
   and nothing for a crawler to miss. The relabel below is only a safety net for anything that
   still emits the old wording (a cached section, a variant swap using window.variantStrings).

   Sold pages deliberately STAY PUBLISHED: the URL keeps the ranking, pins and inbound links it
   earned, which is free long-tail traffic for the pieces still in stock. So the job of a sold page
   is to catch that visitor rather than waste them — we promote the existing "Notify me when a
   similar piece arrives" (assets/anemoia-wishlist.js) from a quiet text link into the page's primary
   action, since with nothing to buy it IS the next step.

   Touches only text and one class. Re-runs on grid re-render (filter/sort/paginate). Guarded. */
(function () {
  'use strict';

  var LABEL = 'Sold';

  function relabel(root) {
    var scope = root || document;

    // Badges — on product cards in the grid and on the product page.
    var badges = scope.querySelectorAll ? scope.querySelectorAll('.price__badge-sold-out, .card__badge .badge') : [];
    Array.prototype.forEach.call(badges, function (b) {
      if (b.getAttribute('data-av-sold')) return;
      if (!/sold\s*out/i.test(b.textContent || '')) return;
      b.setAttribute('data-av-sold', '1');
      b.textContent = LABEL;
    });

    // The buy button, once it's disabled. Dawn puts the label in a <span> beside a spinner.
    var submit = document.querySelector('.product-form__submit');
    if (submit && submit.disabled) {
      var label = submit.querySelector('span') || submit;
      if (/sold\s*out/i.test(label.textContent || '')) label.textContent = LABEL;
    }
  }

  function isSoldPdp() {
    if (!/\/products\//.test(location.pathname)) return false;
    var submit = document.querySelector('.product-form__submit');
    return !!(submit && submit.disabled);
  }

  function css() {
    if (document.getElementById('anemoia-sold-css')) return;
    var s = document.createElement('style');
    s.id = 'anemoia-sold-css';
    s.textContent = [
      /* With nothing to buy, the notify link becomes the page's primary action. */
      '.awl-notify.awl-notify--primary{display:flex !important;align-items:center;justify-content:center;',
      'width:100% !important;text-align:center !important;text-decoration:none !important;',
      'border:1px solid #1f1713 !important;color:#1f1713 !important;background:none;',
      'padding:14px 18px !important;font-size:11px !important;letter-spacing:.16em;text-transform:uppercase;',
      'transition:background .2s ease,color .2s ease;}',
      '.awl-notify.awl-notify--primary:hover{background:#1f1713 !important;color:#f5f2ee !important;}',
      '@media (max-width:749px){.awl-notify.awl-notify--primary{padding:16px 18px !important;font-size:12px !important;}}'
    ].join('');
    document.head.appendChild(s);
  }

  // No extra "this piece is sold" line here: the badge beside the price and the buy button
  // already say it. A third repetition of the same word is noise, not voice.
  function promote() {
    if (!isSoldPdp()) return;
    css();

    var notify = document.querySelector('.awl-notify');
    if (notify && !notify.classList.contains('awl-notify--primary')) {
      notify.classList.add('awl-notify--primary');
    }
  }

  function run() { relabel(document); promote(); }

  function boot() {
    run();
    // The grid re-renders on filter/sort/paginate; the wishlist mounts the notify link late.
    var target = document.getElementById('ProductGridContainer') || document.querySelector('main') || document.body;
    try { new MutationObserver(function () { run(); }).observe(target, { childList: true, subtree: true }); } catch (e) {}
    var n = 0, iv = setInterval(function () { run(); if (++n > 12) clearInterval(iv); }, 400);
    document.addEventListener('shopify:section:load', run);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();